import React, { useState, useCallback, useEffect, useRef } from 'react';
import '../../../../App.css';
import '../../Employees.css';
import {
  LicenseSelect,
  LicenseAllSelect
} from '../../../../common/APICommon';
import {
  domain,
  token,
  HR7_IS_CLOUD,
  getUnliAccount
} from '../../../Security';
import axios from '../../../../api/apiClient';

// reusables
import { DateInputOld as DateInput } from '../../../../common/Input';
import { FEATURES } from '../../../../config/features';

export function PersonalTab({
  employeeId,
  selectedFile,
  setSelectedFile,
  lastName,
  firstName,
  middleName,
  extensionName,
  nickName,
  age,
  dateOfBirth,
  placeOfBirth,
  civilStatus,
  bloodType,
  height,
  weight,
  citizenship,
  religion,
  gender,
  mobileNumber,
  emailAddress,
  deviceNumber,
  companyId,
  license,
  setEmployeeId,
  setLastName,
  setFirstName,
  setMiddleName,
  setExtensionName,
  setNickName,
  setAge,
  setDateOfBirth,
  setPlaceOfBirth,
  setCivilStatus,
  setBloodType,
  setHeight,
  setWeight,
  setCitizenship,
  setReligion,
  setGender,
  setMobileNumber,
  setEmailAddress,
  setDeviceNumber,
  setCompanyId,
  setLicense,

  signature, setSignature,

  employeeStatus = "",

  isEditMode,
  isAddMode = false
}) {

  const allowEdit = isEditMode === true || isAddMode === true;

  const allowModifyEmployeeIdEditMode =
    isEditMode === true &&
    FEATURES.EMPLOYEE_PERSONAL_EDITABLE_EMPLOYEEID === true;

  const allowEmployeeIdEdit =
    isAddMode === true || allowModifyEmployeeIdEditMode;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    // Check if the selected file is an image
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);
    } else {
      // Handle case where non-image file is selected
      alert("Please select an image file.");
    }
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setSignature("");
        return;
      }
    }

    setSignature(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setSignature("");
        return;
      }
    }

    setSignature(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setSignature([]);
    // Reset the value of the file input
    document.getElementById('fileInput').value = '';
  };

  return (
    <div className="personal-tab column">
      <div className="major-info row">
        <div className="major-info-left column">
          <label htmlFor="file-input" className='column' style={{
            color: "#808080b5",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer" // Add cursor pointer for better user interaction
          }}>
            <img src={selectedFile ? URL.createObjectURL(selectedFile) : "images/sample.jpg"} alt=""></img>
            {selectedFile ? selectedFile.name : "Click the placeholder to upload a picture"}
          </label>
          <input
            id="file-input"
            type="file"
            style={{ display: "none" }}
            onChange={handleFileChange}
            disabled={!isEditMode}
          />
        </div>
        <div className="major-info-right column">
          <div className="major-info-right-item info-item-holder row">
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Employee Id<span style={{ visibility: isEditMode ? "visible" : "hidden", color: "red", fontSize: "10px", marginLeft: "5px" }}>(*required)</span></div>
              <div className="info-item-input">
                <input
                  id="AddEmployee-EmployeeId"
                  placeholder="Employee Id"
                  maxLength={20}
                  readOnly={!allowEmployeeIdEdit}
                  value={employeeId}
                  onChange={(e) => setEmployeeId(e.target.value)}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label">Device No.</div>
              <div className="info-item-input">
                <input type='number' id="AddEmployee-DeviceNo" placeholder="Device No"
                  readOnly={!isEditMode} value={deviceNumber} onChange={(e) => setDeviceNumber(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Company<span style={{ visibility: isEditMode ? "visible" : "hidden", color: "red", fontSize: "10px", marginLeft: "5px" }}>(*required)</span></div>
              <div className="info-item-input">{CompanyTypeIdSelect(companyId, setCompanyId, isEditMode)}</div>
            </div>
          </div>
          <div className="major-info-right-item info-item-holder row">
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Last Name<span style={{ visibility: isEditMode ? "visible" : "hidden", color: "red", fontSize: "10px", marginLeft: "5px" }}>(*required)</span></div>
              <div className="info-item-input">
                <input id="AddEmployee-LastName" placeholder="Last Name"
                  readOnly={!isEditMode} value={lastName} onChange={(e) => setLastName(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>First Name<span style={{ visibility: isEditMode ? "visible" : "hidden", color: "red", fontSize: "10px", marginLeft: "5px" }}>(*required)</span></div>
              <div className="info-item-input">
                <input id="AddEmployee-FirstName" placeholder="First Name"
                  readOnly={!isEditMode} value={firstName} onChange={(e) => setFirstName(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>Middle Name</div>
              <div className="info-item-input">
                <input id="AddEmployee-MiddleName" placeholder="Middle Name"
                  readOnly={!isEditMode} value={middleName} onChange={(e) => setMiddleName(e.target.value)}
                /></div>
            </div>
          </div>
          <div className="major-info-right-item info-item-holder row">
            <div className="info-item info-item3 column">
              <div className="info-item-label">Extension Name</div>
              <div className="info-item-input">
                <input id="AddEmployee-ExtensionName" placeholder="Extension Name"
                  readOnly={!isEditMode} value={extensionName} onChange={(e) => setExtensionName(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label">Nick Name</div>
              <div className="info-item-input">
                <input id="AddEmployee-NickName" placeholder="Nick Name"
                  readOnly={!isEditMode} value={nickName} onChange={(e) => setNickName(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label">Gender</div>
              <div className="info-item-input">{Gender(gender, setGender, isEditMode)}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="minor-info column">
        <div className="minor-info-item info-item-holder row">
          <div className="info-item info-item4 column">
            <div className="info-item-label">Civil Status</div>
            <div className="info-item-input">{CivilStatus(civilStatus, setCivilStatus, isEditMode)}</div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Citizenship</div>
            <div className="info-item-input">
              <input id="AddEmployee-Citizenship" placeholder="Citizenship"
                readOnly={!isEditMode} value={citizenship} onChange={(e) => setCitizenship(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Religion</div>
            <div className="info-item-input">
              <input id="AddEmployee-Religion" placeholder="Religion"
                readOnly={!isEditMode} value={religion} onChange={(e) => setReligion(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Age</div>
            <div className="info-item-input">
              <input type='number' id="AddEmployee-Age" placeholder="Age"
                readOnly={!isEditMode} value={age} onChange={(e) => setAge(e.target.value)}
              /></div>
          </div>
        </div>
        <div className="minor-info-item info-item-holder row">
          <div className="info-item info-item4 column">
            <div className="info-item-label">Date Of Birth</div>
            <div className="info-item-input">
              {DateInput(dateOfBirth, setDateOfBirth, isEditMode)}
            </div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Place Of Birth</div>
            <div className="info-item-input">
              <input id="AddEmployee-PlaceOfBirth" placeholder="Place Of Birth"
                readOnly={!isEditMode} value={placeOfBirth} onChange={(e) => setPlaceOfBirth(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Blood Type</div>
            <div className="info-item-input">
              <input id="AddEmployee-BloodType" placeholder="Blood Type" maxLength={3}
                readOnly={!isEditMode} value={bloodType} onChange={(e) => setBloodType(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Mobile Number</div>
            <div className="info-item-input">
              <input id="AddEmployee-MobileNumber" placeholder="Mobile Number"
                readOnly={!isEditMode} value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)}
              /></div>
          </div>
        </div>
        <div className="minor-info-item info-item-holder row" style={{ justifyContent: "normal" }}>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Email Address</div>
            <div className="info-item-input">
              <input id="AddEmployee-EmailAddress" placeholder="Email Address"
                readOnly={!isEditMode} value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Height</div>
            <div className="info-item-input">
              <input id="AddEmployee-Height" placeholder="Height" type="number"
                readOnly={!isEditMode} value={height} onChange={(e) => setHeight(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Weight</div>
            <div className="info-item-input">
              <input id="AddEmployee-Weight" placeholder="Weight" type="number"
                readOnly={!isEditMode} value={weight} onChange={(e) => setWeight(e.target.value)}
              /></div>
          </div>
          {HR7_IS_CLOUD && !getUnliAccount() && (
            <div className="info-item info-item4 column">
              <div className="info-item-label row" style={{ alignItems: "center" }}>
                License Key <span style={{ visibility: isEditMode ? "visible" : "hidden", color: "red", fontSize: "10px", marginLeft: "5px" }}>(*required)</span>
              </div>
              <div className="info-item-input">
                {/* View mode - always show read-only */}
                {!isEditMode ? (
                  <LicenseAllSelect
                    data={license}
                    setData={setLicense}
                    isEditable={false} // Always false in view mode
                  />
                ) : (
                  /* Edit mode - check if user already has license */
                  license && license !== "" ? (
                    // Already has license - show read-only
                    <LicenseAllSelect
                      data={license}
                      setData={setLicense}
                      isEditable={false}
                    />
                  ) : (
                    // No license yet - allow selection
                    <LicenseSelect
                      data={license}
                      setData={setLicense}
                      isEditable={true}
                    />
                  )
                )}
              </div>
            </div>
          )}
        </div>
        <div className="minor-info-item info-item-holder row" style={{ justifyContent: "normal" }}>
          <div className="transaction-form-item row" style={{ paddingTop: "50px", alignItems: "revert" }}>
            <div className="transaction-form-category"><h4 style={{ margin: '0', fontWeight: "bold" }}>Signature: </h4></div>
            <div className="transaction-form-input">

              {isEditMode &&
                <>
                  <label htmlFor="fileInput" className='browse'>Browse...</label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: 'none' }}
                  />
                </>
              }

              {signature.length > 0 ? (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {signature.map((file, index) => (
                      <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{ width: "150px", height: "auto" }}></img>
                    ))}
                  </ul>
                  {isEditMode && <div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
                    <button id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px" }}>
                      CLEAR
                    </button>
                  </div>}
                </div>
              )
                :
                (
                  isEditMode &&
                  <div
                    id='drop-files-here'
                    onDrop={(e) => handleDrop(e)}
                    onDragOver={(e) => handleDragOver(e)}
                    onDragLeave={(e) => handleDragOut(e)}
                    style={{
                      border: '2px dashed #ccc',
                      borderRadius: '5px',
                      padding: '20px',
                      marginTop: '10px',
                      textAlign: 'center',
                    }}
                  >
                    Drop files here
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function Gender(gender, setGender, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setGender(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (gender !== "" && gender !== 0 && gender !== null && gender !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [gender]);

  return (
    <div>
      <select value={gender || ''} onChange={handleSelectChange} disabled={!isEditMode} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
      </select>
    </div>
  );
}

function CivilStatus(civilStatus, setCivilStatus, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setCivilStatus(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (civilStatus !== "" && civilStatus !== 0 && civilStatus !== null && civilStatus !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [civilStatus]);

  return (
    <div>
      <select value={civilStatus || ''} disabled={!isEditMode} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="">None</option>
        <option value="Single">Single</option>
        <option value="Maried">Maried</option>
      </select>
    </div>
  );
}

function CompanyTypeIdSelect(companyId, setCompanyId, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setCompanyId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Company/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.name.localeCompare(b.name));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [companyId]);

  useEffect(() => {
    if (companyId) {
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === companyId.toString());

      if (!foundData) {
        setCompanyId("")
      }
    }

  }, [data, companyId, setCompanyId]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        disabled={!isEditMode}
        value={companyId || ''}
        onChange={handleSelectChange}
        style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}
      >
        <option value="">None</option>
        {data.map((company) => (
          <option key={company.id || company.code || company} value={company.id || company}>
            {/* Display the company name or value here */}
            {company.name || company}
          </option>
        ))}
      </select>
    </div>
  );
};

function SetCompanyType(companyId) {
  return (
    <option value={companyId.id}>{
      companyId.name}
    </option>
  )

}